import React from 'react';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { useMutation, useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { yupErrorMsg } from '../../../../components/atoms/const';
import api from '../../../../components/api';

interface InitValuesData {
  serviceReason: { value: number, label: string } | null,
  clientName: { value: number, label: string } | null,
  vmId: { value: number, label: string } | null,
  comment: string;
  firstname: string;
  lastname: string;
  phoneNumber: string;
  email: string;
  sms: boolean;
}

function useAddService() {
  const navigate = useNavigate();
  const navigateToLanding = () => navigate('/customer-support/services');

  const { mutate: addServiceRequest, isLoading: addServiceLoad } = useMutation(api.customerSupport.addServiceRequest, {
    onMutate: (variables) => console.log(variables),
    onSuccess: (data) => {
      console.log(data);
      alert('success');
      navigateToLanding();
    },
    onError: (error) => {
      console.log(error);
      alert('error');
    },
  });

  const yupSchema = yup.object({
    serviceReason: yup.object().nullable().required(yupErrorMsg.REFUND_REASON_EMPTY),
    email: yup.string().email(yupErrorMsg.EMAIL_INCORRECT_FORMAT),
    vmId: yup.object().nullable().required(yupErrorMsg.VM_EMPTY),
  });

  const initValues: InitValuesData = {
    serviceReason: null,
    clientName: null,
    vmId: null,
    comment: '',
    firstname: '',
    lastname: '',
    phoneNumber: '',
    email: '',
    sms: false,
  };

  const formik = useFormik({
    initialValues: initValues,
    validationSchema: yupSchema,
    onSubmit: (values) => {
      if (!!values.serviceReason?.value && !!values.clientName?.value && !!values.vmId?.value) {
        addServiceRequest({
          serviceReason: values.serviceReason?.value,
          clientName: values.clientName?.value,
          vmId: values.vmId?.value,
          comment: values.comment,
          firstname: values.firstname,
          lastname: values.lastname,
          phoneNumber: values.phoneNumber,
          email: values.email,
          sms: values.phoneNumber === '' ? false : values.sms,
        });
      }
    },
  });

  const { data: clientRes, isLoading: clientLoad } = useQuery(
    ['getAllActive', 'clients'],
    () => api.clients.getAllActive(),
  );
  const clientList = React.useMemo(() => clientRes?.data?.data.map((x) => ({
    value: x.id,
    label: x.name,
  })), [clientRes]);

  const vmList = React.useMemo(() => {
    const resData = clientRes?.data?.data;
    if (clientList && clientList.length && !!formik.values.clientName && resData) {
      const findData = resData.find((x) => x.id === formik.values.clientName?.value);
      return findData?.vendingMachines.map((x) => ({
        value: x.id,
        label: x.deviceId,
      }));
    }
    return [];
  }, [formik.values.clientName]);

  return {
    formik,
    client: {
      list: clientList,
      load: clientLoad,
    },
    vm: {
      list: vmList,
    },
    addServiceLoad,
    navigateToLanding,
  };
}

export default useAddService;
